module.exports = __webpack_public_path__ + "Lato-Bold.25583230b7fa52a5aa21.woff2";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Bold.woff2
// module id = ../../../../../src/assets/fonts/Lato/Lato-Bold.woff2
// module chunks = styles